export const readCache = (k) => { try { return JSON.parse(localStorage.getItem(k)) || null; } catch { return null; } };
export const writeCache = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* quota */ } };
